import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR } from '../../constants';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export default function (state = initialState, action){
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return { ...state, isLoading : true, data: null, error: null };
    case RESET_PASSWORD_SUCCESS:
     return { ...state, data: action.payload, isLoading: false, error: null };
    case RESET_PASSWORD_ERROR:
     return { ...state, error: action.payload, data: null, isLoading: false };

    default:
     return state;
  }
}